// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-EZlmS","item":"item-3YOS3","item_selected":"item_selected-3eKCD","item__icon":"item__icon-3KNmp"};